<template>
    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title"> {{datToChild.mode}} - Detail of {{datToChild.idspecimen_name}}</p>
                <button class="delete" aria-label="close"   ></button>
            </header>

            <section class="modal-card-body">
                <!--                  content-->
                <b-loading  :active.sync="isFullScreenLoading" />
                <b-field label="Name">
                    <b-input   v-model="datToChild.name" />
                </b-field>

                <b-field label="Name" v-if="datToChild.mode === 'Edit' ">
                    <b-switch v-model="datToChild.enable">
                        {{ datToChild.enable }}
                    </b-switch>
                </b-field>



            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button is-danger"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"
                          icon-right="close"
                          @click="close" >Cancel</b-button>
                &nbsp;&nbsp;&nbsp;
                <b-button type="is-success"
                          icon-right="cloud-upload"
                          @click="saveData" >Save</b-button>

            </footer>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {getConfigAxios , getBaseURLforBackEnd  }  from '@/utils.js'
    import { mapState } from "vuex";


    export default {
        name: "AddSpecimensDesc",
        props:{
            datToChild : {}
                              // {"mode" : "Edit" , "idspecimen_type": this.selectedSpecimensType.id ,"idspecimen_name": this.selectedSpecimensType.name, "id": id,"name": dat.name ,"enable" : dat.enable}
                             //  "Add" , "Edit"
        },
        data(){
            return {
                isFullScreenLoading : false
            }
        },
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            })
        },
        methods:{
            close(){
                this.$emit('closeWithNothing')
            },
            closeWithSave(){
                this.$emit('closeWithAddNew')
            },
            closeWithEdit(){
                this.$emit('closeWithEdit')
            },
            saveData(){
                if( this.datToChild.mode === 'Add' ){
                    if(this.datToChild.name.length>0){
                        this.addData()
                    }else{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: 'pls enter some text to to save!!!',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    }

                }else if( this.datToChild.mode === 'Edit' ){
                    if(this.datToChild.name.length>0){
                        this.editData()
                    }else{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: 'pls enter some text to to save!!!',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    }

                }else{
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Something goes error, pls contact to admin',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }

            },
            addData(){
                const datTo = {
                    "idspecimen_type" : this.datToChild.idspecimen_type ,
                    "name": this.datToChild.name,
                }
                 // console.log(datTo)
                const vm = this
                this.isFullScreenLoading = true

                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/addspecimensdescp`,datTo,getConfigAxios())
                    .then((res)=>{
                        if(res.status === 200){
                            vm.$buefy.toast.open({
                                message: `Success to save`,
                                type: 'is-success'
                            })
                            vm.isFullScreenLoading = false
                            vm.closeWithSave()
                        }
                    })
                    .catch((err)=>{
                        vm.isFullScreenLoading = false
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })
            },
            editData(){
                    const datTo = {
                        "id" : this.datToChild.id,
                        "name": this.datToChild.name,
                        "enable": this.datToChild.enable
                    }

                    // console.log(datTo)
                    const vm = this
                    this.isFullScreenLoading = true
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                    axios.post(`${getBaseURLforBackEnd()}/api/updatespecimensdescp`,datTo,getConfigAxios())
                        .then((res)=>{
                            if(res.status === 200){
                                vm.$buefy.toast.open({
                                    message: `Success to update`,
                                    type: 'is-success'
                                })
                                vm.isFullScreenLoading = false
                                vm.closeWithEdit()
                            }
                        })
                        .catch((err)=>{
                            vm.isFullScreenLoading = false
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                        })
            }
        }
    }
</script>

<style scoped>

</style>